import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">

      {/* ─── HEADER ─── */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Left: Logo + Name */}
          <div className="flex items-center gap-3">
            <img src="/bits-logo.png" alt="BITS Logo" className="h-14 w-14 object-contain" />
            <div className="hidden sm:block leading-tight">
              <p className="text-sm font-bold text-black">BITS VIZAG (AUTONOMOUS)</p>
              <p className="text-xs font-semibold text-gray-600">EAMCET EXAM PORTAL</p>
            </div>
          </div>

          {/* Right: Nav buttons */}
          <nav className="flex items-center gap-1">
            {/* Student */}
            <button
              onClick={() => navigate('/student/register')}
              className="relative px-3 py-2 text-sm font-medium text-gray-500 group transition-all duration-200"
            >
              <span className="group-hover:text-black transition-colors duration-200">Register</span>
              <span className="absolute bottom-0.5 left-3 right-3 h-px bg-black scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
            </button>

            {/* Admin */}
            <Link
              to="/admin/login"
              className="relative px-3 py-2 text-sm font-medium text-gray-500 group transition-all duration-200"
            >
              <span className="group-hover:text-black transition-colors duration-200">Admin</span>
              <span className="absolute bottom-0.5 left-3 right-3 h-px bg-black scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
            </Link>

            {/* Exam Login — premium black button */}
            <Link
              to="/login"
              className="relative ml-2 px-5 py-2 text-sm font-bold text-white rounded-lg overflow-hidden group transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-gray-400/30"
            >
              <span className="absolute inset-0 bg-black group-hover:bg-gradient-to-r group-hover:from-gray-900 group-hover:to-gray-700 transition-all duration-300 rounded-lg"></span>
              <span className="relative flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 group-hover:scale-125 transition-transform duration-200"></span>
                Exam Login
              </span>
            </Link>

            {/* Contact Us */}
            <a
              href="#contact"
              className="relative px-3 py-2 text-sm font-medium text-gray-500 group transition-all duration-200"
            >
              <span className="group-hover:text-black transition-colors duration-200">Contact Us</span>
              <span className="absolute bottom-0.5 left-3 right-3 h-px bg-black scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
            </a>
          </nav>
        </div>
      </header>

      {/* ─── CENTER: Title ─── */}
      <main className="flex-grow flex items-center justify-center px-6">
        <div className="text-center">
          <img src="/bits-logo.png" alt="BITS Logo" className="h-36 w-36 object-contain mx-auto mb-8" />
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-black tracking-tight leading-snug mb-2">
            BABA INSTITUTE OF TECHNOLOGY<br />AND SCIENCES (AUTONOMOUS)
          </h1>
          <p className="text-base md:text-lg font-semibold text-gray-600 mb-4">EAMCET Mock Test Portal</p>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Register as a student or log in to access your exam. Hall Ticket Numbers are assigned by the admin before the exam.
          </p>
        </div>
      </main>

      {/* ─── FOOTER: Contact Us ─── */}
      <footer id="contact" className="border-t border-gray-200 bg-gray-50 py-3">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold text-gray-600">Contact Us — For inquiries, reach out to the administration.</p>
          <p className="text-xs text-gray-400 mt-0.5">&copy; {new Date().getFullYear()} BITS Vizag. All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
}
